import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/products", label: "Products" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="container-custom">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/images/logo.png" alt="Rupved Agro Logo" className="h-12 w-auto" />
          </Link>
          <div className="hidden md:flex space-x-8">
            {navItems.map(item => (
              <NavLink key={item.path} to={item.path} className={({ isActive }) => `text-lg font-medium transition-colors duration-300 hover:text-primary ${isActive ? "text-primary border-b-2 border-primary" : "text-spice-dark"}`}>
                {item.label}
              </NavLink>
            ))}
          </div>
          <button className="md:hidden text-3xl" onClick={() => setIsOpen(!isOpen)}>☰</button>
        </div>
        <AnimatePresence>
          {isOpen && (
            <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} className="md:hidden overflow-hidden">
              <div className="flex flex-col space-y-4 pb-4">
                {navItems.map(item => (
                  <NavLink key={item.path} to={item.path} onClick={() => setIsOpen(false)} className={({ isActive }) => `text-lg font-medium transition-colors duration-300 ${isActive ? "text-primary" : "text-spice-dark"}`}>
                    {item.label}
                  </NavLink>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default Navbar;